<template>
    <div v-if="!isloading" class="component-container">
        <div class="textinput-container">
            <div
                v-if="finalname"
                class="label-container"
                :style="labelStyle"
                :class="{ 'error' : error }"
            >
                <label>{{ finalname }}</label>
            </div>
            <input
                v-if="!toggleDisplay"
                :id="inputid"
                :class="{ 'error' : error }"
                :style="inputStyle"
                :type="password ? 'password' : 'text'"
                :value="modelValue"
                :required="isrequired"
                :placeholder="placeholder"
                :disabled="isdisabled"
                @keyup.enter="onenter"
                @input="handleInput($event.target.value)"
            />
            <label v-else>{{ modelValue }}</label>
        </div>
    </div>
    <div v-else class="input-line-loading-placeholder shimmer big"></div>
</template>

<script>
const EMITS = {
    UPDATE_MODEL_VALUE: 'update:modelValue'
}

export default {
    name: 'FloatingInput',
    props: {
        isrequired: {
            type: Boolean,
            default: false
        },
        isdisabled: {
            type: Boolean,
            default: false
        },
        labelStyle: {
            type: String,
            default: ''
        },
        inputStyle: {
            type: String,
            default: ''
        },
        toggleDisplay: {
            type: Boolean,
            default: false
        },
        isloading: {
            type: Boolean,
            default: false
        },
        password: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: undefined
        },
        modelValue: {
            type: [ Number, String ],
            default: undefined
        },
        placeholder: {
            type: String,
            default: undefined
        },
        inputid: {
            type: String,
            default: undefined
        },
        error: {
            type: Boolean,
            default: false
        },
        onenter: {
            type: Function,
            default: undefined
        }
    },
    emits: Object.values(EMITS),
    computed: {
        finalname() {
            if (this.isrequired) {
                return this.title + '*'
            } else {
                return this.title
            }
        }
    },
    methods: {
        handleInput: function(value) {
            this.$emit(EMITS.UPDATE_MODEL_VALUE, value)
        }
    },
}
</script>

<style scoped>
.component-container {
    width: 100%;
    text-align: left;
}

.label-container {
    position: absolute;
    text-align: left;
    font-size: 0.8em;
    left: 10px;
    top: -7.5px;
    padding: 0 5px;
    background: var(--color-fg-default);
    border-radius: 10px;
}

.textinput-container {
    width: 100%;
    position: relative;
}

input {
    width: 100%;
    padding-top: 5px;
    padding-left: 10px;
}

.error {
    color: red;
    border-color: red;
}
</style>